import React from "react";
import { Card, CardTitle, CardBody } from "reactstrap";
import { format, parseISO, isSameDay } from "date-fns";
import classnames from "classnames";

import { Event } from "../../api/index";

interface AttendeeEventsProps {
  data: Event[] | undefined;
}

const AttendeeEvents = ({ data }: AttendeeEventsProps) => {

  const lastIndex = (data?.length ?? 0) - 1;

  const getTime = (date: string) =>
    format(parseISO(date), "dd/MM/yyyy");

  return (
    <Card className="attendeeAttended">
      <CardBody className="p-0">
        <CardTitle
          tag="h5"
          className="mt-3 text-primary text-center text-uppercase fs-9 fw-6"
        >
          {data
            ? data.length === 1
              ? "1 Event Attended"
              : `${data.length} Events Attended`
            : "Events Attended"}
        </CardTitle>
        <div style={{ minHeight: "3rem" }}>
          {!!data && !!data.length && (
            <div className="border-top scroll scroll-auto custom-scrollbar">
              {(data ?? []).map((event, i) => (
                <div key={i} className={classnames({
                  "p-2": true,
                  "border-bottom": i !== lastIndex,
                })}>
                  <div className="title font-weight-bold text-light">{event.name}</div>
                  <div className="fs-10 pt-1">
                    {getTime(event.start)}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default AttendeeEvents;
